import React, { ReactNode } from 'react';
import './Patterns.css';

export type StatusVariant = 'ok' | 'warn' | 'danger' | 'info' | 'queued';

export interface StatusPillProps {
  variant: StatusVariant;
  children: ReactNode;
}

const StatusPill: React.FC<StatusPillProps> = ({ variant, children }) => (
  <span className={`pat-status-pill pat-status-pill--${variant}`}>{children}</span>
);

export default StatusPill;
